import { render, staticRenderFns } from "./OrderBumpAdd.vue?vue&type=template&id=72747b09&scoped=true&"
import script from "./OrderBumpAdd.vue?vue&type=script&lang=js&"
export * from "./OrderBumpAdd.vue?vue&type=script&lang=js&"
import style0 from "./OrderBumpAdd.vue?vue&type=style&index=0&id=72747b09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72747b09",
  null
  
)

export default component.exports